import {
  IonCard,
  IonButton,
  IonInput,
  IonNote,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  IonCardHeader,
  IonContent,
  IonPage,
  IonCardTitle,
  IonCardContent,
  IonImg,
  useIonViewWillEnter,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Preferences } from "@capacitor/preferences";
import { BewohnerZusatzstoffe } from "../components/_funktionen/bewohner_zusatzstoffe";
import { RezeptZusatzstoffe } from "../components/_funktionen/rezept_zusatzstoffe";
import { Servierhinweise } from "../components/_funktionen/servierhinweise";
import { mk_ion_header } from "../functions/mk_ion_header";

import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { ButtonBackToSpeisekarte } from "../components/_funktionen/button_back_to_speisekarte";
import { send_data } from "../functions/send_data";

export default function Mahlzeit() {
  const { zeit, woche, datumsql } = useParams<any>();

  const zeit_labels: any = {
    1: ["frueh", "Früh", "Frühstück"],
    3: ["abend", "Abend", "Abendessen"],
  };

  const { appBewohnerSollId, appBewohnerSollBezeichnung, appBewohnerZusatzstoffe, appServer, appToken } = useContext(DataContext);

  let datum_info = `- ${new Date(datumsql).toLocaleDateString("de-DE", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}`;

  const [komponenten, setKomponenten] = useState<any>([]);
  const [auswahl, setAuswahl] = useState<any>();
  const [servierhinweise, setServierhinweise] = useState<any>();

  const [bewohnerBemerkung, setBewohnerBemerkung] = useState<any>("");

  const checkBewohner = async () => {
    const { value } = await Preferences.get({ key: "senioren.bewohner" });
    if (value) {
      JSON.parse(value).forEach((entry: any) => {
        if (entry.betriebe_bewohner_id === appBewohnerSollId) {
          setBewohnerBemerkung([entry.bewohner_bemerkung, entry.bewohner_sonderkost].join(" "));
        }
      });
    }
  };

  useIonViewWillEnter(() => {
    const get_preference = async (key: string) => {
      const { value } = await Preferences.get({ key: "senioren." + key });
      if (!value) {
        return null;
      } else return value;
    };
    get_preference("token").then(() => {
      get_preference(zeit_labels[zeit][0]).then((res: any) => {
        setSpeiseplan(JSON.parse(res));
      });
      get_preference("auswahl").then((res: any) => {
        setAuswahl(JSON.parse(res));
      });
    });
    checkBewohner();
  });

  let json = [
    {
      speiseplan_id: "552787",
      wieder_speiseplan_id: "419",
      speiseplan_tag: "2022-05-19",
      speiseplan_kategorie: "1",
      speiseplan_rezepte_id: "3249",
      speiseplan_forecast: "0",
      speiseplan_produktion: "0",
      speiseplan_ist: "0",
      speiseplan_text: "Kaffee",
      speiseplan_status: null,
      speiseplan_betriebe_id: "2",
      speiseplan_plan_id: "2",
      speiseplan_rezept_piktogramm: "0",
      speiseplan_preis: "",
      speiseplan_optik: null,
      speiseplan_geschmack: null,
      speiseplan_konsistenz: null,
      speiseplan_geruch: null,
      speiseplan_temperatur: null,
      speiseplan_sensorik_von: null,
      speiseplan_sensorik_bemerkung: null,
      rezepte_id: "3249",
      rezepte_bezeichnung: "Kaffee",
      rezepte_anweisung: "        ",
      rezepte_rezeptgruppen: "24",
      rezepte_kellen_id: "1",
      rezepte_interner_preis: "",
      rezepte_vk_preis: "",
      rezepte_status: "1",
      rezepte_freigabe: "Torsten Kempf",
      rezepte_datum: "2022-04-20 06:59:02",
      rezepte_ursprung: "2795",
      rezepte_arten: "1",
      rezepte_garverlust: "0",
      rezepte_anmerkung_ausgabe: "",
      rezepte_bild: null,
      rezepte_bestelleinheit: "Portion",
      rezepte_bestelleinheit2: "",
      rezepte_bestelleinheit_faktor2: "0.00",
      rezepte_bestelleinheit3: "",
      rezepte_bestelleinheit_faktor3: "0.00",
      rezepte_bestelleinheit4: "",
      rezepte_bestelleinheit_faktor4: "0.00",
      rezepte_steuer_id: "1",
      rezepte_verkaufsbezeichnung: "Kaffee",
      betriebe_speiseplaene_id: "2",
      betriebe_speiseplaene_bezeichnung: "Frühstück WSD",
      betriebe_speiseplaene_betriebe_id: "2",
      betriebe_speiseplaene_typ: "2",
      betriebe_speiseplaene_zeit: "1",
      betriebe_speiseplaene_komponenten: "0",
      betriebe_speisepläne_vers: "1",
    },
  ];
  const [speiseplan, setSpeiseplan] = useState<any>(json);

  function mk_angebote() {
    return speiseplan.map((entry: any, index: any) => {
      return mk_angebot_kachel(entry, index);
    });
  }
  const [angebot, setAngebot] = useState<any>(mk_angebote());

  function mk_angebot_kachel(angebot_data: any, index: any) {
    let disable = false;
    if (Array.isArray(angebot_data.rezepte_zusatzstoffe)) {
      if (
        angebot_data.rezepte_zusatzstoffe.findIndex((entry: any) => {
          return appBewohnerZusatzstoffe.includes(entry);
        }) > -1
      ) {
        disable = true;
      }
    }
    return (
      <IonCol key={"card_" + index} size-xs={6} size-sm={6} size-md={4} size-lg={4} size-xl={4}>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>
              {angebot_data.rezepte_bezeichnung} <RezeptZusatzstoffe rezepte_zusatzstoffe={angebot_data.rezepte_zusatzstoffe} />
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            {disable ? (
              <div style={{ height: "5em", textAlign: "center" }}>
                <i>nicht auswählbar wegen bekannter Unverträglichkeit</i>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <IonNote slot="start">
                  {" "}
                  <IonButton
                    disabled = { komponenten[angebot_data.speiseplan_rezepte_id] ? false : true }
                    size="large"
                    onClick={() => change_menge( angebot_data.speiseplan_rezepte_id, index, '-' ) }
                  >
                    -
                  </IonButton>
                </IonNote>
                <IonInput
                  disabled
                  type="text"
                  style={{ textAlign: "center" }}
                  size={2}
                  slot="end"
                  value={komponenten[angebot_data.speiseplan_rezepte_id] ? komponenten[angebot_data.speiseplan_rezepte_id] : 0}
                ></IonInput>
                {komponenten[angebot_data.speiseplan_rezepte_id] * 1 != 4 ? (
                  <IonNote slot="end">
                    {" "}
                    <IonButton
                      size="large"
                      onClick={() => change_menge( angebot_data.speiseplan_rezepte_id, index, '+' ) }
                      >
                      +
                    </IonButton>
                  </IonNote>
                ) : (
                  ""
                )}
              </div>
            )}
            <IonImg
              src={
                angebot_data.rezepte_bild && angebot_data.rezepte_bild.split("-")[0]
                  ? appServer + "/bilder/ofw/rezepte/" + angebot_data.rezepte_bild
                  : appServer + "/konfig/evkw/bilder/keinBild.jpeg"
              }
              onClick={() => change_menge( angebot_data.speiseplan_rezepte_id, index, '+', disable ) }
              style={{ opacity: disable ? "0.3" : "1.0" }}
            ></IonImg>
          </IonCardContent>
        </IonCard>
      </IonCol>
    );
  }

  function addKomponente(rezept: any, index: any, newvalue: any) {
    let alt_komponenten = komponenten;
    alt_komponenten[rezept] = newvalue;
    setKomponenten(alt_komponenten);
    send_data(appServer, appToken, appBewohnerSollId, rezept, newvalue, zeit, datumsql);
    setAngebot(mk_angebote());
  }

  function change_menge(rezept: any, index: any, change: '+'|'-'|1, disable = false ) {
    if( disable ) return ;
    let my_new_menge = komponenten[ rezept ] ? komponenten[ rezept ] * 1 : 0 ;
    if( change === '+' ) ++my_new_menge ;
    if( change === '-' && komponenten[ rezept ] > 0 ) --my_new_menge;
    if( my_new_menge !== komponenten[ rezept ] ) addKomponente( rezept, index, my_new_menge ) ;
}

  useEffect(() => {
    let alt_komponenten: any = [];
    auswahl &&
      auswahl.map((entry: any) => {
        if (entry.bewohner_verzehr_zeit === zeit) {
          if (entry.bewohner_verzehr_tag === null) alt_komponenten[entry.rezepte_id] = entry.bewohner_verzehr_menge;
        }
      });
    setKomponenten(alt_komponenten);
    setServierhinweise(<Servierhinweise bewohnerid={appBewohnerSollId} zeit={zeit_labels[zeit][1]} />);
  }, [appBewohnerSollId, auswahl, zeit]);

  useEffect(() => {
    setAngebot(mk_angebote());
  }, [komponenten]);

  return (
    <IonPage>
      {mk_ion_header(`${zeit_labels[zeit][2]} ${appBewohnerSollBezeichnung} ${datum_info}`)}
      <IonContent fullscreen>
        {mk_ion_header(`${zeit_labels[zeit][2]} ${appBewohnerSollBezeichnung} ${datum_info}`, "large")}
        <ButtonBackToSpeisekarte />
        {woche == "0" ? <IonItem>Es kann nicht mehr bestellt werden</IonItem> : ""}
        <IonItem>
          {servierhinweise}
          <BewohnerZusatzstoffe bewohnerid={appBewohnerSollId} />
          {bewohnerBemerkung && bewohnerBemerkung}
        </IonItem>
        <IonGrid>
          <IonRow>{angebot}</IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
}
